import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-push-clean-pcc',
  templateUrl: './push-clean-pcc.component.html',
  styleUrls: ['./push-clean-pcc.component.scss']
})
export class PushCleanPccComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
